import { useTranslations } from 'next-intl';

import { ProcessingMintRequest } from '@flipster/apis/v1/earn/types';
import { FormattedMessage } from '@flipster/i18n';
import { Datetime } from '@flipster/react/design-utils/datetime';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

export const ProcessingMintRequestsContents = ({
  processingMintRequests,
}: {
  processingMintRequests: ProcessingMintRequest[];
}) => {
  const t = useTranslations();
  return (
    <div className={stack()}>
      <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-2' })}>
        <FormattedMessage
          id='Autogen_common.r251126.s_processingMintRequests_length_pending'
          values={{
            processingMintRequests_length: processingMintRequests.length,
          }}
        />
      </span>
      {processingMintRequests.map((request) => (
        <div
          key={`${request.confirmedAt}-${request.collateralCurrency}-${request.providerCurrency}`}
          className={stack({ gap: 2, py: 4 })}
        >
          <p className={css({ textStyle: 'Text/S/Monospace/Regular', color: 'content.default.level-5' })}>
            {request.side === 'MINT' &&
              t(
                'Autogen_common.r251126.s_Mint_request_providerCurrency_with_numberFormatter_request_collateralCurrency',
                {
                  request_providerCurrency: request.providerCurrency,
                  numberFormatter: numberFormatter(request.fromAmount, {
                    precision: UsdtPrecision,
                    withComma: true,
                    toFixed: true,
                  }),
                  request_collateralCurrency: request.collateralCurrency,
                },
              )}
            {request.side === 'REDEEM' &&
              t(
                'Autogen_common.r251126.s_Redeem_numberFormatter_request_providerCurrency_for_request_collateralCurrency',
                {
                  numberFormatter: numberFormatter(request.fromAmount, {
                    precision: UsdtPrecision,
                    withComma: true,
                    toFixed: true,
                  }),
                  request_providerCurrency: request.providerCurrency,
                  request_collateralCurrency: request.collateralCurrency,
                },
              )}
          </p>
          <p className={css({ textStyle: 'Text/S/Monospace/Regular', color: 'content.default.level-2' })}>
            {/* TODO: [sh] format이 이런 이유가 궁금하신가요?*/}
            {/* ref: https://www.figma.com/design/8bOVdAiCXUkWMyC8g7HdCk?node-id=10156-56681&m=dev#1454682398 */}
            <Datetime value={request.confirmedAt} format='MM/dd/yy HH:mm:ss' isUTC withUTCText />
          </p>
        </div>
      ))}
    </div>
  );
};
